import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { withIdentity, IdentityProps } from 'src/core/services/authentication';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import autobind from 'autobind-decorator';
import {withUserProfile} from "./components/user-profile";

export interface TelemetryProps extends RouteComponentProps, IdentityProps {
    instrumentationKey: string;
    aiConnectionString: string;
    aiRoleName: string;
}

interface TelemetryProviderState {
    ai: any;
    identityId: string;
}

const { Provider, Consumer } = React.createContext<ApplicationInsights>(undefined as any);
let reactPlugin = new ReactPlugin();
class TelemetryProvider extends React.Component<TelemetryProps,TelemetryProviderState> {
    constructor(props: TelemetryProps) {
        super(props);        
        this.state = {
            ai: undefined,
            identityId: this.props.identity.email ?? ""
        }
    }

    @autobind
    setUserContext(userId: string) {
        var validatedId = userId.replace(/[,;=| ]+/g, "_");
        if (this.state.ai && this.props.identity.email) {            
            this.state.ai.setAuthenticatedUserContext(validatedId);
        }       
    }

   componentDidUpdate(prevProps: TelemetryProps) {
        if (prevProps.identity.email != this.props.identity.email) {
            this.setUserContext(this.state.identityId); 
        }        
    }

    componentWillMount() {        
        const { history } = this.props;
        const initialized = Boolean(this.state.ai);
        const AppInsightsInstrumentationKey = this.props.instrumentationKey as any;
        const AppInsightsConnectionString = this.props.aiConnectionString as any;
        if (!initialized && Boolean(AppInsightsInstrumentationKey || AppInsightsConnectionString) && Boolean(history)) {
            
            let appInsights = new ApplicationInsights({
                config: {
                    connectionString: AppInsightsConnectionString,
                    instrumentationKey: AppInsightsInstrumentationKey,
                    maxBatchInterval: 0,
                    disableFetchTracking: false,
                    autoTrackPageVisitTime: true,                    
                    extensions: [reactPlugin as any],
                    
                    extensionConfig: {
                        [reactPlugin.identifier]: {
                            history: history
                        }
                    }
                }
            });            
            appInsights.loadAppInsights();
            appInsights.addTelemetryInitializer((envelope) => {
                if (envelope && envelope.tags) {
                    envelope.tags["ai.cloud.role"] = this.props.aiRoleName;
                }
                                
            })
            this.setState({ ai: appInsights }, () => this.setUserContext(this.state.identityId));
            console.log('application insights initialized')    
        }
                        
    }

    render() {
        return <Provider value={this.state.ai as any}>{this.props.children}</Provider> || <div></div>
    }
}

export function withAITelemetry<T extends React.ComponentClass<any, any>>(Component: T) {
    // ...and returns another component...
    return function ComponentBoundWithAppContext(props: any) {
        // ... and renders the wrapped component with the current context!
        // Notice that we pass through any additional props as well
        return (
            <Consumer>
                {appContext => <Component {...props} ai={appContext} />}
            </Consumer>
        );
    };
}
export default withUserProfile(withIdentity(withRouter(withAITracking(reactPlugin as any, TelemetryProvider, 'AITracker', 'TelemetryProvider')) as any));
export const aiPlugin = reactPlugin;